/**
 * ATS types exports.
 */

export * from './campaign';
export * from './cv';
export * from './job';
export * from './job-assignment';
export * from './member-role';
export * from './pipeline';
export * from './pool';
export * from './position';
export * from './note';
export * from './share';
export * from './work-arrangement';
export * from './job-description';
export * from './analysis';
export * from './calendar';
export * from './calendar-event-type';
export * from './email';
export * from './email-signature';

/** Must match backend BULK_CV_LIMIT / BULK_POOL_LIMIT */
export const BULK_CV_LIMIT = 50;
export const BULK_POOL_LIMIT = 20;
